import { PATHS } from 'commons/paths';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetPageProps, UserRegistrationState } from 'hooks/u002/useUserRegistrationHooks';
import { Button } from 'atoms/Button';
import { AuditionTopPage } from 'pages/AuditionFormTop';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { TransitionButton } from 'atoms/TransitionButton';

//U002F01 アカウント確認画面
type TopProps = GetPageProps<UserRegistrationState, 'Top'> & { title: string };
export const Top: FC<TopProps> = (props) => {
  const nav = useNavigate();
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');

  const handleNotHasAccount = () => props.onNext();

  const handleHasAccount = () => {
    const toParam = new URLSearchParams();
    toParam.set('redirect', window.location.pathname);
    const to = PATHS.LOGIN + '?' + toParam.toString();
    nav(to);
  };

  return (
    <div aria-live="polite">
      <div role="heading" aria-live="assertive" aria-level={1} className="sr-only">
        {props.title}
      </div>
      <AuditionTopPage title={props.title}>
        <div className="m-8 text-center mt-40">
          <Button
            className="w-[14rem]"
            onClick={handleHasAccount}
            label={tAuditionForm('TU002_002')}
          />
        </div>
        <div className="m-8 text-center">
          <TransitionButton
            className="w-[14rem]"
            onClick={handleNotHasAccount}
            label={tAuditionForm('TU002_001')}
          />
        </div>
      </AuditionTopPage>
    </div>
  );
};
